import Vue from 'vue'
import Router from 'vue-router'

import store from '@/vuex/store';

// Pipeline
import middlewarePipeline from './middleware/middleware-pipeline';

// Routes
import siteRoutes from './routes/site-routes';
import authRoutes from './routes/auth-routes';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        siteRoutes,
        authRoutes,
        {
            path: '*',
            name: 'not-found',
            component: () => import('@/views/site/NotFound'),
        },
    ],
});

// Middleware checker
router.beforeEach(async (to, from, next) => {
    // Initial auth check
    if (!store.getters['auth/isAuthChecked']) {
        try {
            await store.dispatch('auth/checkAuth');
        } catch (err) {
            //
        } finally {
            store.dispatch('setIsLoading', false);
        }
    }

    if (!to.meta.middleware) {
        return next();
    }

    const middleware = to.meta.middleware;
    const context = {to, from, next, store};

    middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1)
    });
});

export default router;